<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  .task {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 1rem;
    position: relative;
    scroll-margin-bottom: 2rem;

    &:not(:last-child):not(.isLastNonOptional)::after {
      content: "";
      position: absolute;
      left: 11px;
      top: 61px;
      bottom: -25px;
      width: 2px;
      background-color: $secondary-border-color;
      z-index: 0;
      border-radius: 1rem;
    }

    &.isLastNonOptional {
      margin-bottom: 10px;
    }

    &.completed {
      &::after {
        background-color: $turquoise;
      }
    }

    &.pending {
      &::after {
        background-color: $orange;
      }
    }

    &.current {
      @keyframes growFromTop {
        from {
          height: 0;
        }
        to {
          height: 50%;
        }
      }

      @keyframes shrinkFromBottom {
        from {
          height: 50%;
        }
        to {
          height: 0;
        }
      }

      &::after {
        background-color: $secondary-border-color;
      }

      &::before {
        &:not(:last-child) {
          content: "";
          position: absolute;
          left: 11px;
          top: 61px;
          width: 2px;
          background-color: $turquoise;
          z-index: 1;
          border-radius: 1rem;
          height: 0;
          transition: height 0.3s ease;
        }
      }

      &.expanded::before {
        height: 50%;
      }

      &:not(.expanded)::before {
        height: 0;
      }

      &.animate-enabled {
        &.expanded::before {
          animation: growFromTop 0.3s ease forwards;
        }

        &:not(.expanded)::before {
          animation: shrinkFromBottom 0.3s ease forwards;
        }
      }
    }

    .task-wrapper {
      text-align: left;
      background: 0;
      border: 0;
      border-radius: 0.5rem;
      transition: 0.3s ease;
      border-color: $light-blue;
      border: 1px solid white;

      &:hover {
        background: $light-blue;
      }

      &.expanded {
        background: #f6fcff;
        border: 1px solid $light-blue;
      }
    }
  }
</style>

<script>
  import { interactiveTasks } from "../stores";
  import ProgressIndicator from "./ProgressIndicator.svelte";
  import TaskContent from "./TaskContent.svelte";
  import TaskHeader from "./TaskHeader.svelte";

  export let task;

  $: completed = task.status === "completed";
  $: current = task.status === "current";
  $: pending = task.status === "pending";
  $: expanded = $interactiveTasks.selectedTaskId === task.taskId;
  $: status = task.status;
  $: lastCompleted = task.lastCompleted || false;
  $: isFirstOptional = task.isFirstOptional;
  $: isLastNonOptional = task.isLastNonOptional;
  $: isNewSubgroup = task.isNewSubgroup;
</script>

<article
  id={task.taskId}
  class="task"
  class:completed
  class:current
  class:pending
  class:expanded
  class:isFirstOptional
  class:isLastNonOptional
  class:isNewSubgroup
>
  <ProgressIndicator {status} {lastCompleted} />
  <div class="task-wrapper" class:expanded>
    <TaskHeader {task} />
    <TaskContent {task} />
  </div>
</article>
